import clsx from 'clsx';
import { AmountUtils, ColorUtils, DateUtils } from '@shared/utils';
import type { GetPaymentsByRecipientIdResponse } from '@shared/api/rest/payment';
import { Table, TableCellType } from '@shared/widgets';

interface ITableProps {
  data?: GetPaymentsByRecipientIdResponse[];
  isLoading?: boolean;
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}

export const RecipientTable = (props: ITableProps) => {
  return (
    <Table
      isLoading={props.isLoading}
      isScrollable
      columns={['Status', 'Date', 'Description', 'Total Amount', 'Amount', 'Direction']}
      items={
        props.data?.map((row) => {
          const { bg, label, text } = ColorUtils.getDepositPaymentStatusStyles(row.paymentStatus);
          return [
            {
              type: TableCellType.Custom,
              value: <div className={clsx('py-1 px-2 text-center font-normal', `bg-opacity-10`, bg, text)}>{label}</div>,
            },
            { type: TableCellType.Text, value: DateUtils.formatDate(row.createdDate) },
            { type: TableCellType.Text, value: row.description || '-' },
            { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.totalAmount, row.currency) },
            { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(row.amount, row.currency) },
            { type: TableCellType.Text, value: row.paymentDirection },
          ];
        }) || []
      }
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
